import { createGenericSlice } from '../genericSlice.js';
import { getCurrency } from './thunks.js';
import initialState from './initialState.js';
import '@reduxjs/toolkit';
import 'lodash/set';
import '../../types/index.js';
import '../../checkout-Ee1eEXQH.js';
import '../../menu-0TyOg98i.js';
import '../../product-_pRduMz7.js';
import '../../modal-6vnX5SO3.js';
import '../../GetCurrencies-HOmikd_V.js';
import '../../requestsCollection-gritD79O.js';
import 'react';
import 'graphql-request';
import 'lodash/cloneDeep';
import 'lodash/get';
import '../../services/auth/index.js';
import '../../utils/logToSlack.js';
import '../../utils/cookies.js';
import 'cookies-next';
import '../../cookies-l-jEMp6P.js';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-YC9H491Y.js';
import '../../utils/isBot.js';
import '../../utils/currency.js';
import '../../context/index.js';
import 'next/router';
import '../../helpers-kA_hdoOI.js';
import '../../utils/product.js';
import '../../utils/logger.js';
import '../../paths-ZKN3m62_.js';
import 'lodash';
import '../../utils/fetchPolicyLookup.js';
import '../../utils/error.js';
import '../../serverErrors-_VHsjhgw.js';
import '../../utils/logToRelic.js';

const currenciesSlice = createGenericSlice({
    name: 'currencies',
    initialState,
    reducers: {
        setCurrentCurrencyCode: (state, { payload }) => {
            state.currentCurrencyCode = payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(getCurrency.fulfilled, (state, { payload }) => {
            state.currencyCodes = payload.currencyCodes;
            state.currentCurrencyCode = payload.currentCurrencyCode;
        });
    },
});
const { setCurrentCurrencyCode } = currenciesSlice.actions;
var index = currenciesSlice.reducer;

export { index as default, setCurrentCurrencyCode };
//# sourceMappingURL=index.js.map
